var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.845 17.2251L39.845 7.47508C39.5776 7.36246 39.2903 7.30444 39 7.30444C38.7098 7.30444 38.4225 7.36246 38.155 7.47508L12.155 17.2251C11.6869 17.3931 11.2824 17.7021 10.9972 18.1095C10.712 18.5169 10.5602 19.0028 10.5625 19.5001V31.7851C10.5625 51.9351 21.255 66.8201 38.48 70.7851H39.52C56.745 66.9826 67.4375 52.0976 67.4375 31.7851V19.5001C67.4399 19.0028 67.288 18.5169 67.0028 18.1095C66.7176 17.7021 66.3131 17.3931 65.845 17.2251ZM50.57 34.1251L38.87 47.1251C38.641 47.3811 38.3605 47.5858 38.0469 47.7259C37.7332 47.8659 37.3935 47.938 37.05 47.9376C36.7072 47.9341 36.3687 47.8601 36.0556 47.7203C35.7426 47.5806 35.4616 47.378 35.23 47.1251L27.43 38.4801C27.0065 37.994 26.7898 37.3616 26.8262 36.7179C26.8627 36.0742 27.1493 35.4703 27.625 35.0351C27.8618 34.8194 28.1388 34.6525 28.4401 34.5439C28.7415 34.4354 29.0613 34.3873 29.3812 34.4024C29.7011 34.4175 30.015 34.4955 30.3048 34.6319C30.5945 34.7684 30.8546 34.9606 31.07 35.1976L37.05 41.8601L46.8 30.8751C47.231 30.3924 47.8361 30.1007 48.4821 30.0641C49.1282 30.0275 49.7623 30.2491 50.245 30.6801C50.7277 31.1111 51.0194 31.7161 51.056 32.3622C51.0926 33.0083 50.871 33.6424 50.44 34.1251H50.57Z",
    fill: "url(#paint0_linear_402_141)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_141",
    x1: 16.8025,
    y1: 56.6801,
    x2: 61.1975,
    y2: 12.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94FFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security_icon.5236b4ba92c82f91e29d509751cfb5c3.svg";
export { ForwardRef as ReactComponent };